angular
    .module("home.controller")
    .controller('resetPasswordController', ['$scope', '$rootScope', '$routeParams', '$location', '$timeout', 'userService', 'commonService', 'popupService',
        function ($scope, $rootScope, $routeParams, $location, $timeout, userService, commonService, popupService) {
            //Clean token data from session storage
            userService.clearAuthenticatedSession();
            sessionStorage.removeItem('Token');

            $scope.token = $routeParams.token;

            $scope.formName = $location.path().indexOf('activation') > -1 ? "Activate your account" : "Reset your password";
            $scope.isActivationForm = $location.path().indexOf('activation') > -1 ? true : false;

            $timeout(function () {
                $scope.resetPasswordTemplate = true;
            });

            $scope.submitted = false;
            $scope.deviceStyle = "";
            $scope.tokenIsValid;
            $scope.serverLoading = true; // hide content before server load complete

            $scope.isValidPassword = true;

            $scope.userModel = {
                identifier: '',
                email: '',
                newPassword: '',
                repeatPassword: '',
                token: $scope.token
            };
           
            // cannot used ng-minlength in this case because it prevents 'equalTo' rule by adding minlength to html,
            // it cannot trigger newPassword value change event until it pass the min-length rule
            $scope.checkValidPassword = function () {
                $scope.isValidPassword = userService.isPasswordValid($scope.userModel.newPassword);
            };
            $scope.userResetPassword = function () {
                $scope.submitted = true;
                if (!this.resetPasswordForm.$valid) {
                    resetInputForm();
                    return;
                }

                commonService.veryfiToken($scope.token).then(function (result) {
                    if (!!result.Success && !!result.Identifier) {
                        resetPassword();

                    } else {
                        $scope.tokenIsValid = false;
                        $scope.messageFromServer = result.ErrorMessage;
                    }
                });
            };

            function resetPassword() {
                userService.resetPassword($scope.userModel).then(function (result) {
                    var message;
                    var otpions = {                       
                        okCallback: function () {
                            //Redirect user to homepage
                            $location.path('/');
                        },
                        additionClass: 'popup-box-small'
                    };
                    
                    if (result.Success) {
                        message = $scope.isActivationForm ?
                            "You have successfully set your password." :
                            "You have successfully reset your password.";
                        popupService.showDialog(message, undefined, otpions);
                    } else {
                        message = result.ErrorMessage !== "" ? result.ErrorMessage :
                            ($scope.isActivationForm ?
                                "You set your password fail." :
                                "You reset your password fail.");
                       
                        popupService.showError(message);

                        resetInputForm();
                    }
                });
            }

            function veryfiToken() {
                commonService.veryfiToken($scope.token, $location.path().indexOf('activation') > -1).then(function (result) {
                    if (!!result.Identifier) {
                        $scope.userModel.email = result.Email;
                        $scope.userModel.identifier = result.Identifier;
                    } else {
                        $scope.messageFromServer = result.ErrorMessage;
                    }

                    $timeout(function () {
                        $scope.tokenIsValid = !!result.Identifier;
                        setTimeout(function () {
                            $('#newPassword').focus();

                        }, 100);
                    });

                    // server load completed
                    $scope.serverLoading = false;
                });
            }

            function resetInputForm() {
                $scope.userModel.newPassword = '';
                $scope.userModel.repeatPassword = '';
            }

            $scope.passwordResetPopup = function () {
                $rootScope.closePopups();
                $rootScope.passwordResetPopupOn = !$rootScope.passwordResetPopupOn;
            };

            veryfiToken();
        }
    ]);